module.exports = __webpack_public_path__ + "img/passport.ebc8bd40.png";